import api from "./apiServices"
import { getAPIConfig } from "../utils/apiUtils"

export const loadConfigApi = () => api.load(`/config`)
export const loadProductApi = (hashedID, params) => api.load(`/products/${hashedID}`, params)
export const loadCountriesApi = () => api.load("/countries")
export const loadCheckOrderApi = (orderID, params) => api.load(`/orders/${orderID}/check`, params)
export const loadOrderApi = (orderID, params) => api.load(`/orders/${orderID}`, params)
export const loadCheckLocationApi = () => api.loadLocationInfo()
export const loadSSOApi = (token) => api.loadSSO({ token })
export const createOrderApi = (data) => api.create(`/orders`, data)
export const incrementFailedTryCountApi = (orderID, params) => api.update(`/orders/${orderID}/failed_try_count`, null, params)
export const checkSupplierApi = (data) => api.create(`/check_supplier`, data)
